{
  "dropzoneLabel": "Ablegebereich",
  "selectPlaceholder": "Element wählen",
  "tableResizer": "Größenanpassung",
  "colorSwatchPicker": "Color swatches"
}
